import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { useRuntimeStore } from "@/store/runtime"
import { usePacksStore } from "@/store/packs";
import { useFilesStore } from "@/store/files";
import { useApi } from "@/service/api"

// import url only of an asset

// import url_prova from '@/assets/geojson/prova.json?url'
import url_grigliato_utm_4000_32632 from '@/assets/geojson/grigliato_utm_4000_32632.json?url'
import url_vda_cfce_32632 from '@/assets/geojson/vda_cfce_32632.json?url'
import url_confinepngp_epsg32632_aggiornato from '@/assets/geojson/confinepngp_epsg32632.json?url'
import url_nidi_aquile_epsg32632 from '@/assets/geojson/nidi_aquile_epsg32632.json?url'
import url_sorveglianza_epsg32632 from '@/assets/geojson/sorveglianza_epsg32632.json?url'

// function TMSURLFunctionBinder(baseURL) {
//     return (coordinate) => {
//         const z = coordinate[0];
//         const x = coordinate[1];
//         const y = (1 << z) - coordinate[2] - 1;
//         return baseURL + z + '/' + x + '/' + y + '.jpg';
//     }
// }

export const useMapStore = defineStore('mapStore', () => {
    const runtimeStore = useRuntimeStore();
    const packsStore = usePacksStore()

    const filesStore = useFilesStore()

    const api = useApi()

    const layers = {}


    // ==================== BASE LAYERS ====================
    const defaultBaseLayers = [
        {
            id: 'osm',
            projection: 'EPSG:3857',
            type: 'tile',
            source_type: 'osm',
            title: 'OSM',
            source: "internet",
            visible: true,
            active: true,
            minZoom: 1,
            maxZoom: 18,
        },
        {
            id: 'google',
            projection: 'EPSG:3857',
            type: 'tile',
            source_type: 'xyz',
            title: 'Ortofoto',
            source: "internet",
            visible: false,
            active: true,
            url: 'https://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}',
            minZoom: 1,
            maxZoom: 18,
        },

        {
            id: 'opentopomap',
            projection: 'EPSG:3857',
            type: 'tile',
            source_type: 'xyz',
            title: 'OpenTopoMap',
            source: "internet",
            visible: false,
            active: true,
            url: 'https://a.tile.opentopomap.org/{z}/{x}/{y}.png',
            minZoom: 1,
            maxZoom: 18,
        },

    ]


    const baseLayers = ref([])


    const mesi = [
        'Gennaio', 'Febbraio', 'Marzo', 'Aprile',
        'Maggio', 'Giugno', 'Luglio', 'Agosto',
        'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
    ];

    const oggi = new Date();
    const meseCorrente = oggi.getMonth(); // Restituisce 0 (Gennaio) a 11 (Dicembre)
    const mesePrecedente = (oggi.getMonth() - 1 + 12) % 12;


    // ==================== OVERLAY LAYERS ====================
    const overlayLayers = ref([
        // {
        //     id: 'prova',
        //     properties: { selectable: true, },
        //     component: "GeoJSONVectorLayerURL",
        //     projection: 'EPSG:4326',
        //     type: 'GeoJSON',
        //     title: 'prova',
        //     visible: false,
        //     active: true,
        //     url: url_prova,
        // },
        {
            id: 'utm_4000',
            properties: { selectable: false, },
            component: "GeoJSONVectorLayerURL",
            projection: 'EPSG:4326',
            type: 'GeoJSON',
            title: 'UTM 4000',
            visible: false,
            active: true,
            url: url_grigliato_utm_4000_32632,
        },
        {
            id: 'vda_cfce',
            properties: { selectable: false, },
            component: "GeoJSONVectorLayerURL",
            projection: 'EPSG:4326',
            type: 'GeoJSON',
            title: 'CFCE',
            visible: false,
            active: true,
            url: url_vda_cfce_32632,
        },
        {
            id: 'confine_pngp_aggiornato',
            properties: { selectable: false, },
            component: "GeoJSONVectorLayerURL",
            projection: 'EPSG:32632',
            type: 'GeoJSON',
            title: 'Confine PNGP',
            visible: false,
            active: true,
            url: url_confinepngp_epsg32632_aggiornato,
        },
        {
            id: 'nidi_aquile',
            properties: { selectable: true, },
            component: "GeoJSONVectorLayerURL",
            projection: 'EPSG:32632',
            type: 'GeoJSON',
            title: 'Nidi aquile',
            visible: false,
            active: true,
            url: url_nidi_aquile_epsg32632,
        },
        {
            id: 'ibex_previous_month',
            properties: { selectable: true, },
            component: "GeoJSONVectorIbexPreviousMonth",
            projection: 'EPSG:4326',
            type: 'GeoJSONInLocalstorage',
            title: 'Stambecchi',
            description: `Contiene le segnalazioni \"Stambecco\" di tutti gli utenti.<br>
            <span style="display: inline-block; height: 1em; width: 1em; border: .2em solid white; border-radius: .5em; background: #442211; margin-bottom: -.2em;" ></span> →
            segnalazioni inserite nel mese precedente (${mesi[mesePrecedente]})<br>
            <span style="display: inline-block; height: 1em; width: 1em; border: .2em solid white; border-radius: .5em; background: #DD3322; margin-bottom: -.2em;" ></span> →
            segnalazioni inserite nel mese corrente, (${mesi[meseCorrente]})<br>
            Il dato è aggiornato durante l'avvio dell'applicazione, necessita connettività.`,
            visible: false,
            active: true,
        },
        {
            id: 'q250',
            properties: { selectable: false, },
            component: "layerQ250",
            projection: 'EPSG:32632',
            type: 'GeoJSON',
            title: 'Quadranti 250',
            visible: false,
            active: true,
        },


        {
            id: 'settori_sorveglianza',
            properties: { selectable: false, },
            component: "GeoJSONVectorLayerURL",
            projection: 'EPSG:32632',
            type: 'GeoJSON',
            title: 'Settori',
            visible: false,
            active: true,
            url: url_sorveglianza_epsg32632,
            label: "nome",
        },
    ])


    // ==================== ANNOTAZIONI LAYERS ====================
    const annotazioniLayers = ref([
        {
            id: 'annotazioni_personali',
            which: 'annotazioni_personali',
            properties: { selectable: true, },
            component: "AnnotazioniLayer",
            visible: false,
            active: true,
        },


        {
            id: 'annotazioni_colleghi',
            which: 'annotazioni_colleghi',
            properties: { selectable: true, },
            component: "AnnotazioniLayer",
            visible: false,
            active: true,
        },
    ])



    // ==================== WEBSERVER LAYERS ====================


    const searchWebServerForMaps = async () => {

        console.log("🌍 🔍 searchWebServerForMaps")


        const foundLayers = []


        const folder_content = await api.local.list("/tiles/")

        console.log(folder_content)


        if (folder_content.data !== null) {

            for (const entry of folder_content.data) {

                console.log(entry.name)

                if (["..", "."].includes(entry.name)) continue
                if (!entry.directory) continue

                let name = entry.name



                let url = `${api.localWebServerURL}/tiles/${entry.name}/`
                let extension = 'jpg'

                let source_type = 'xyz'
                // if (name.includes("osm")) source_type = 'osm'
                if (name.includes("ctr")) {
                    // console.log('name.includes("ctr")')
                    source_type = 'tms'
                }

                if (name.includes("ortofoto")) {
                    // console.log('name.includes("ortofoto")')
                    source_type = 'tms'
                }

                if (source_type == 'xyz') {
                    url = `${url}{z}/{x}/{y}.${extension}`
                }

                if (source_type == 'tms') {
                    url = `${url}{z}/{x}/{-y}.${extension}`
                }

                let title = name

                title = title.split("_")[0]

                if (title.length < 4) {
                    title = title.toUpperCase()
                }
                else {
                    title = title.charAt(0).toUpperCase() + title.slice(1)
                }

                foundLayers.push({
                    active: true,
                    id: entry.name + "_tiles_webserver",
                    type: "tiles-folder",
                    source_type: source_type,
                    title: title,
                    label: name,
                    source: "localwebserver",
                    visible: false,
                    active: true,
                    url: url,
                    extent: [
                        781934.9806508283363655,    // 3857
                        5679667.4050984131172299,
                        848558.3316170207690448,
                        5734497.0189472911879420,
                    ],
                    minZoom: 1,
                    maxZoom: 17,
                })

            }

            console.log("foundLayers")
            console.log(foundLayers)
        }



        return foundLayers




        // // alert(JSON.stringify(result_tiles))


        // const result_lures = await api.local.list("/lures/")
        // console.log(result_lures)
        // // alert(JSON.stringify(result_lures))
        // const fake = {
        //     "response": {}, "data": [{
        //         "name": "..",
        //         "length": 0,
        //         "modified": 1730239893601,
        //         "directory": true
        //     },
        //     {
        //         "name": "pngp-ortofoto-1-17.mbtiles",
        //         "length": "362.9 MB",
        //         "modified": 1730239879669,
        //         "directory": false
        //     }
        // ]}
        if (result_mbtiles_folder.data !== null) {
            for (const mbtile_file of result_mbtiles_folder.data) {

                if (["..", "."].includes(mbtile_file.name)) continue

                let name = mbtile_file.name

                if (name.includes(".mbtiles")) {
                    name = name.replace(".mbtiles", "")
                }

                let source_type = 'xyz'
                if (mbtile_file.name.includes("osm")) source_type = 'osm'

                foundLayers.push({
                    active: true,
                    id: name + "_mbtiles_webserver",
                    type: "mbtiles-single-file",
                    source_type: source_type,
                    title: name,
                    label: name,
                    source: "localwebserver",
                    visible: false,
                    active: true,
                    url: `${api.localWebServerURL}/mbtiles/${mbtile_file.name}`,
                    extent: [
                        781934.9806508283363655,    // 3857
                        5679667.4050984131172299,
                        848558.3316170207690448,
                        5734497.0189472911879420,
                    ],
                    minZoom: 1,
                    maxZoom: 17,
                })

            }
        }


        return foundLayers

    }




    // ==================== USER LAYERS ====================
    const userLayers = ref([])

    const setUserLayers = async () => {

        filesStore.filterByObj({ purpose: "userlayer" }).then(async (files) => {

            userLayers.value = []

            for (const { id } of files) {

                const file = await filesStore.get(id)
                const cb46 = file.content.split("base64,")[1]
                const json_content = JSON.parse(atob(cb46))
                // const json_content = JSON.parse(file.content)

                userLayers.value.push({
                    id: file.id,
                    properties: { selectable: true, },
                    component: "GeoJSONVectorLayerURL",
                    projection: 'EPSG:4326',
                    type: 'GeoJSON',
                    title: json_content.type,
                    visible: false,
                    active: true,
                    content: json_content,
                })
            }
        })
    }

    setUserLayers()
    // const baseLayers = ref(standardBaseLayers.concat(rasterMbtilesLayers.value))

    const getMapPacksFromCacheablePacks = () => {
        // console.log(packsStore)
        console.log("🌍 🔍 getMapPacksFromCacheablePacks")

        const tilesPacks = packsStore.cachedPacks.filter((pack) => {
            if (pack.type === "mbtiles-single-file") return true
            if (pack.type === "pmtiles-raster") return true
            if (pack.type === "pmtiles-vector") return true

            return false
        })

        const SingleFileLayerFrompacksStore = []

        tilesPacks.forEach((pack) => {

            for (const file of pack.files) {
                SingleFileLayerFrompacksStore.push({
                    id: file.id,
                    properties: { 
                        selectable: false, 
                        config: file,
                    },
                    type: file.type,
                    source: "cache",
                    title: file.title,
                    visible: false,
                    active: true,
                    url: file.url,
                    extent: file.extent,
                    label: file.title,
                })
            }
        })
        console.log("tilesPacks: ", tilesPacks)
        console.log("SingleFileLayerFrompacksStore: ", SingleFileLayerFrompacksStore)
        return SingleFileLayerFrompacksStore
    }




    const userPk = runtimeStore?.session?.user?.pk
    if (!userPk) {
        console.log("👤 userPk not found")
        return { layers }
        return {}  // better ?
    }

    // if (localStorage.getItem("layers")) {
    //     layers.value = JSON.parse(localStorage.getItem("layers"))
    // }

    const deleteUserLayer = async (id) => {
        await filesStore.deleteByFilter({ purpose: "userlayer", id: id })
        console.log("🌍 UserLayer deleted", id)
        setUserLayers()
    }


    const saveLayers = () => {
        const layersData = {
            baseLayers: baseLayers.value,
            overlayLayers: overlayLayers.value,
            userLayers: userLayers.value,
            annotazioniLayers: annotazioniLayers.valuan
        }
        console.log(layersData)
        // layersData.baseLayers = baseLayers.value
        runtimeStore.session.map.layers = layersData
        runtimeStore.saveSession()
        console.log("🌍 layers data saved")
    }



    const restoreLayersProperties = async () => {


        console.log("🌍 layers data restoring")
        console.log("🌍 ", runtimeStore.session?.map?.layers)
        const layersData = runtimeStore.session?.map?.layers

        if (!layersData) {
            console.log("🌍 ❌ no layers data to restore")
            saveLayers()
            return
        }
        for (const [section_name, section] of Object.entries(layers)) {
            for (const [layer_idx, layer] of Object.entries(section.value)) {

                layer.visible = layersData?.[section_name]?.[layer_idx]?.visible
                layer.active = layersData?.[section_name]?.[layer_idx]?.active === false ? false : true

            }
        }

        console.log("🌍 layers data restored (from session)")

    }



    const refreshLayers = async () => {

        console.log("🌍 🔍 layers refresh")


        baseLayers.value = []
        baseLayers.value = baseLayers.value.concat(defaultBaseLayers)


        if (runtimeStore.session.settings.packsDownloadLocation === 'cache') {
            await packsStore.checkFilePacksTree()
            baseLayers.value = baseLayers.value.concat(getMapPacksFromCacheablePacks())
        }


        if (runtimeStore.session.settings.packsDownloadLocation === 'filesystem') {
            // if (ENVIRONMENT !== 'development') {
            baseLayers.value = baseLayers.value.concat(await searchWebServerForMaps())
            // }
        }


        layers["overlayLayers"] = overlayLayers
        layers["baseLayers"] = baseLayers
        layers["userLayers"] = userLayers
        layers["annotazioniLayers"] = annotazioniLayers

        // for (const lay of layers.value.baseLayers) {
        //     console.log("🌍 layer "+lay.id +" 👀 "+ lay.visible)
        // }

        restoreLayersProperties()

        for (const lay of layers.baseLayers.value) {
            if (lay.active && lay.visible) {
                console.log("🌍 ✅ layer " + lay.id)
            }
            else {
                console.log("🌍 ⬛️ layer " + lay.id)
            }
        }
        //layers.value[key] = value
    }

    // const userData = computed(() => layers[userPk])


    // searchWebServerForMaps()

    return {
        // userData,
        layers,         // da eliminare in qualche modo
        baseLayers,
        overlayLayers,
        userLayers,
        annotazioniLayers,
        deleteUserLayer,
        setUserLayers,
        saveLayers,
        refreshLayers,
        searchWebServerForMaps,
    }

})



